module.exports = __webpack_public_path__ + "static/media/branding-logo.2683a9c9.png";